// זיהוי הסביבה: האתר בתוך האפליקציה (מעטפת Cordova שטוענת את האתר ב-InAppBrowser), ואיזו גרסה שלה.
// מגרסה 1.0.11 האפליקציה מוסיפה AshdodMenuApp ל-User-Agent ומזריקה את window.AshdodApp
// (openExternal), לפעמים רק כמה שניות אחרי הטעינה, ואז שולחת את האירוע window 'ashdodapp'.
// גרסאות ישנות יותר נראות כמו WebView רגיל.
// כל פונקציה בודקת מחדש בכל קריאה, כי window.AshdodApp יכול להגיע אחרי הטעינה.

const ua = () => (typeof navigator !== 'undefined' && navigator.userAgent) || '';

export const APP_READY_EVENT = 'ashdodapp';

export const isNewApp = () => !!window.AshdodApp || /AshdodMenuApp/.test(ua());
const isOtherInAppBrowser = () => /FBAN|FBAV|FB_IAB|Instagram|Line\/|Twitter|TikTok|Snapchat|LinkedInApp/i.test(ua());
const isAndroidWebView = () => /Android/i.test(ua()) && /; wv\)/.test(ua());
const isIosWebView = () => /iPhone|iPad|iPod/i.test(ua()) && !/Safari\//.test(ua());
// כל WebView, כולל הדפדפנים הפנימיים של פייסבוק / אינסטגרם
export const isInApp = () => isNewApp() || isAndroidWebView() || isIosWebView();
export const isOldApp = () => !isNewApp() && !isOtherInAppBrowser() && (isAndroidWebView() || isIosWebView());
export const appPlatform = () => isAndroidWebView() ? 'android' : isIosWebView() ? 'ios' : null;

// פתיחת כתובת מחוץ לאפליקציה דרך window.AshdodApp (מגרסה 1.0.11). מחזיר true אם טופל.
export const openViaApp = (url) => {
    try {
        if (window.AshdodApp && typeof window.AshdodApp.openExternal === 'function') {
            window.AshdodApp.openExternal(url);
            return true;
        }
    } catch (e) { }
    return false;
};

// כתובת שיוצאת מהאתר (דומיין אחר או סכמה שאינה http), ולא ניווט פנימי
export const isExternalUrl = (url) => {
    if (!url) return false;
    try {
        const u = new URL(url, window.location.href);
        if (!/^https?:$/.test(u.protocol)) return true;
        return u.host !== window.location.host;
    } catch (e) {
        return false;
    }
};

// משותף ל-AppPromo ול-AppUpdatePrompt
// עמודי הזמנה ותשלום - לא מציגים בהם
export const NO_PROMO_PATHS = ['/MyOrder', '/TakeOrDel', '/deliAdress', '/thankU', '/ErrorPay', '/LoginPage', '/UserDetails'];
export const HIDE_DAYS = 3;

export const hiddenRecently = (key) => {
    try {
        const at = Number(localStorage.getItem(key));
        return !!at && (Date.now() - at) < HIDE_DAYS * 24 * 60 * 60 * 1000;
    } catch (e) {
        return false;
    }
};

export const rememberHidden = (key) => {
    try { localStorage.setItem(key, String(Date.now())); } catch (e) { }
};

// בורר העיר פתוח, או עומד להיפתח (הערים עוד לא נטענו)
export const cityPickerBlocking = ({ cities, city, needsMyCity, ready, pickerOpen }) =>
    !ready || (cities.length > 0 && (pickerOpen || !city || needsMyCity));
